<template>
  <div
    v-if="Object.keys(props.headerData).length > 0"
    class="header"
    :class="immersiveTitle && 'chenjinshi'"
    :style="{
      backgroundImage: 'url(' + props.headerData.backgroundImgUrl + ')',
      paddingTop: barHeihgt + 'px',
    }"
  >
    <h1 class="title">{{ props.headerData.sceneCollName }}</h1>
    <p>
      <span class="content">
        {{ props.headerData.summary }}
      </span>
      <span class="more" v-if="props.headerData.summaryJumpUrl" @click="handleJump">查看更多<img class="more-img" src="~@/assets/more@3x.png" /></span>
    </p>
    
  </div>
</template>

<script setup>
import { onMounted, reactive, ref, toRefs, onBeforeUnmount, nextTick } from "vue";
import * as tools from "@/utils/utils";
import JUMP from '@/utils/jump'
const props = defineProps({
  headerData: Object,
});
// 沉浸式渲染
const immersiveTitle = tools.isNewTop(6000);
const barHeihgt = ref(0);
const getBarHeight = () => {
  if (tools.inJrApp) {
    window.JrBridge.callNative(
      {
        type: "74",
      },
      (data) => {
        if (data && data.navBarTotalHeightDp) {
          barHeihgt.value = parseInt(data.navBarTotalHeightDp);
        }
      }
    );
  }
};
const handleJump = () => {
  let jumpData = {
    jumpType: 7,
    jumpUrl: props.headerData.summaryJumpUrl
  }
  JUMP(jumpData)
}
onMounted(() => {
  getBarHeight()
});
</script>

<style scoped lang='scss'>
.header {
  position: relative;
  padding: 44px 24px 50px;
  background-position-x: 0;
  background-position-y: 0;
  background-repeat: no-repeat;
  background-size: 100% auto;
  .title {
    width: 100%;
    font-size: 40px;
    font-family: PingFang SC;
    font-weight: 600;
    color: rgba(255, 255, 255, 1);
    padding-top: 44px;
    margin-bottom: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-block-start: 0;
    // margin-block-end: 0;
  }
  .content {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: normal;
    color: rgba(255, 255, 255, 0.8);
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    word-break: break-all;
  }
  .more {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(255,255,255,0.9);
    display: inline-flex;
    align-items: center;
  }
  .more-img {
    width: 26px;
    height: 26px;
  }
}
// 开启沉浸式
.chenjinshi {
  padding-top: 180px;
}
</style>